
<template>
  <BreadCrumb PageTitle="Transaction" />
  <div class="row" v-if="user">
    <div class="col-xxl-12">
      <TransactionContent :selectedEmail = "route.query.email" />
    </div>
  </div>
</template>

<script setup>
// import { defineComponent } from "vue";
import { useRoute } from 'vue-router';
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import TransactionContent from "../../components/Admin/Transaction/TransactionContent.vue";

import { useAccountStore } from "@/stores"
import { storeToRefs } from 'pinia';
const route = useRoute();
const accountStore = useAccountStore();
const { user } = storeToRefs(accountStore);
</script>